import React from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

export const ACCOUNT_DETAILS_NAV_ITEMS = [
  { id: "profile", label: "Profile" },
  { id: "basic-info", label: "Basic info" },
  { id: "contact", label: "Contact" },
  { id: "location", label: "Location" },
  { id: "social-links", label: "Social links" },
  { id: "volunteer", label: "Volunteer" },
  { id: "civix-profile", label: "Civix profile" },
  { id: "billing", label: "Billing & plan" },
  { id: "recovery-email", label: "Recovery email" },
  { id: "security", label: "Security" },
  { id: "blocked-accounts", label: "Blocked accounts" },
  { id: "account-type", label: "Account type" },
  { id: "delete-account", label: "Delete account" },
];

export default function AccountDetailsSideNav({ showBilling = true }) {
  const location = useLocation();
  const activeId = (location.hash || "").replace("#", "") || "profile";
  const navItems = showBilling
    ? ACCOUNT_DETAILS_NAV_ITEMS
    : ACCOUNT_DETAILS_NAV_ITEMS.filter((item) => item.id !== "billing");

  return (
    <Box
      component="nav"
      aria-label="Account sections"
      sx={{
        display: { xs: "none", lg: "block" },
        width: 184,
        flexShrink: 0,
        position: "sticky",
        top: 96,
        pt: 1,
      }}
    >
      <Box
        component="ul"
        sx={{
          listStyle: "none",
          m: 0,
          p: 0,
          display: "flex",
          flexDirection: "column",
          gap: 0.25,
        }}
      >
        {navItems.map((item) => {
          const isActive = activeId === item.id;
          return (
            <Box component="li" key={item.id}>
              <Box
                component="a"
                href={`#${item.id}`}
                sx={{
                  display: "block",
                  py: 0.75,
                  px: 0.5,
                  fontSize: 15,
                  lineHeight: 1.45,
                  color: "#0f172a",
                  fontWeight: isActive ? 700 : 500,
                  textDecoration: "none",
                  borderLeft: "2px solid",
                  borderColor: isActive ? "#047857" : "transparent",
                  pl: 1.25,
                  transition: "border-color 0.15s ease, font-weight 0.15s ease",
                }}
              >
                {item.label}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
